import { SUMMIT_TILES, CRAG_TILES, RIDGELINE_TILES, FOOTHILL_TILES, } from "../definitions/tiles.js";
import { validateTile } from "./types.js";
export * from "./types.js";
export * from "../definitions/tiles.js";
export * from "./slots.js";
export * from "./assembly.js";
/** Every catalogued tile (code defaults). Grows one altitude zone at a time. */
export const ALL_TILES = [
    ...SUMMIT_TILES,
    ...CRAG_TILES,
    ...RIDGELINE_TILES,
    ...FOOTHILL_TILES,
    // TODO: forest tiles — blocked on the board's missing outer hex ring; see
    // the Forest section note in ../definitions/tiles.ts.
];
/** Index a tile catalogue by id (match snapshot or code defaults). */
export function tileIndex(tiles) {
    return new Map(tiles.map((t) => [t.id, t]));
}
/** Tiles for a given altitude zone from an arbitrary catalogue. */
export function tilesForZoneIn(tiles, zone) {
    return tiles.filter((t) => t.zone === zone);
}
/** Look up a tile in an arbitrary catalogue. */
export function tileByIdIn(tiles, id) {
    return tiles.find((t) => t.id === id);
}
/** Tiles for a given altitude zone (code-default catalogue). */
export function tilesForZone(zone) {
    return tilesForZoneIn(ALL_TILES, zone);
}
const TILE_BY_ID = tileIndex(ALL_TILES);
/** Look up a tile in the code-default catalogue. Prefer `tileByIdIn` /
 * `GameConfig.tiles` for match logic. */
export function tileById(id) {
    return TILE_BY_ID.get(id);
}
/**
 * Replay an assembled board's per-node vigor zone from its placements: every
 * node a placed tile covers takes that tile's `zone`; nodes no tile covers are
 * absent (callers default them to `forest`). Pure + deterministic, so a client
 * can reproduce the server's zones from synced `placements` + the (geometric,
 * also-derived) `slots` alone — the same "derive, don't sync" rule the board
 * topology follows. Pass the match's pinned `tiles` catalogue when available so
 * a resumed game resolves against the definitions it started with.
 */
export function zonesFromPlacements(slots, placements, tiles = ALL_TILES) {
    const slotById = new Map(slots.map((s) => [s.id, s]));
    const byId = tileIndex(tiles);
    const zoneByNode = new Map();
    for (const p of placements) {
        const slot = slotById.get(p.slot);
        const tile = byId.get(p.tileId);
        if (!slot || !tile)
            continue;
        for (const id of slot.nodeIds)
            zoneByNode.set(id, tile.zone);
    }
    return zoneByNode;
}
// Fail fast at module load if any catalogued tile is malformed.
for (const tile of ALL_TILES)
    validateTile(tile);
//# sourceMappingURL=index.js.map